module.exports = __webpack_public_path__ + "img/index12.0e436d3d.png";